
<template>
  <div class="dashboard">

    <el-row :gutter="20" style="margin-top:20px">

      <!-- 总笔数 -->
      <el-col :span="8">
        <el-card class="stat-card purple-card" shadow="hover">

          <div class="card-title">
            <i class="fa fa-list-alt"></i>
            {{ $t('home.allCnt') }}
          </div>

          <div class="card-value">
            {{ stats.allCnt || 0 }}
          </div>

          <div class="card-desc">
            {{ $t('home.allCnt') }}
          </div>

        </el-card>
      </el-col>



      <!-- 成功笔数 -->
      <el-col :span="8">
        <el-card class="stat-card green-card" shadow="hover">

          <div class="card-title">
            <i class="fa fa-check-circle"></i>
            {{ $t('home.allSuccCnt') }}
          </div>

          <div class="card-value">
            {{ stats.allSuccCnt || 0 }}
          </div>

          <div class="card-desc">
            {{ $t('home.allSuccCnt') }}
          </div>

        </el-card>
      </el-col>



      <!-- 成功率 -->
      <el-col :span="8">
        <el-card class="stat-card orange-card" shadow="hover">

          <div class="card-title">
            <i class="fa fa-pie-chart"></i>
            {{ $t('home.allSuccRate') }}
          </div>

          <div class="card-value">
            {{ stats.allSuccRate || 0 }}%
          </div>

          <div class="card-desc">
            {{ $t('home.allSuccRate') }}
          </div>

        </el-card>
      </el-col>


    </el-row>



    <!-- 邮箱统计 -->
    <el-row :gutter="20" style="margin-top:20px">

      <el-col :span="8">
        <el-card class="stat-card purple-card" shadow="hover">

          <div class="card-title">
            <i class="fa fa-envelope"></i>
            {{ $t('home.allUniqueEmails') }}
          </div>

          <div class="card-value">
            {{ stats.allUniqueEmails || 0 }}
          </div>

          <div class="card-desc">
            {{ $t('home.allUniqueEmails') }}
          </div>

        </el-card>
      </el-col>



      <el-col :span="8">
        <el-card class="stat-card green-card" shadow="hover">

          <div class="card-title">
            <i class="fa fa-envelope-open"></i>
            {{ $t('home.succUniqueEmails') }}
          </div>

          <div class="card-value">
            {{ stats.succUniqueEmails || 0 }}
          </div>

          <div class="card-desc">
            {{ $t('home.succUniqueEmails') }}
          </div>

        </el-card>
      </el-col>



      <el-col :span="8">
        <el-card class="stat-card orange-card" shadow="hover">

          <div class="card-title">
            <i class="fa fa-line-chart"></i>
            {{ $t('home.emailSuccessRate') }}
          </div>

          <div class="card-value">
            {{ stats.emailSuccessRate || 0 }}
          </div>

          <div class="card-desc">
            {{ $t('home.emailSuccessRate') }}
          </div>

        </el-card>
      </el-col>


    </el-row>



    <!-- 卡号统计 -->
    <el-row :gutter="20" style="margin-top:20px">


      <el-col :span="8">

        <el-card class="stat-card purple-card" shadow="hover">

          <div class="card-title">
            <i class="fa fa-credit-card"></i>
            {{ $t('home.allUniqueCard') }}
          </div>


          <div class="card-value">
            {{ stats.allUniqueCard || 0 }}
          </div>


          <div class="card-desc">
            {{ $t('home.allUniqueCard') }}
          </div>

        </el-card>

      </el-col>




      <el-col :span="8">

        <el-card class="stat-card green-card" shadow="hover">

          <div class="card-title">
            <i class="fa fa-credit-card"></i>
            {{ $t('home.succUniqueCard') }}
          </div>


          <div class="card-value">
            {{ stats.succUniqueCard || 0 }}
          </div>


          <div class="card-desc">
            {{ $t('home.succUniqueCard') }}
          </div>

        </el-card>

      </el-col>



      <el-col :span="8">

        <el-card class="stat-card orange-card" shadow="hover">


          <div class="card-title">
            <i class="fa fa-line-chart"></i>
            {{ $t('home.cardSuccessRate') }}
          </div>


          <div class="card-value">
            {{ stats.cardSuccessRate || 0 }}
          </div>


          <div class="card-desc">
            {{ $t('home.cardSuccessRate') }}
          </div>


        </el-card>

      </el-col>


    </el-row>

<!--    <el-row :gutter="20" class="chart-section">

      <el-col :span="16">
        <el-card shadow="hover" class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-table"></i> {{ $t('home.WeeklyData') }}</span>
          </div>
          <el-table :data="weeklyData" style="width: 100%" height="300" stripe>
            <el-table-column prop="trDate" :label="$t('home.Date')" width="150" align="center"></el-table-column>
            <el-table-column prop="succAmount" :label="$t('home.succAmount')" align="center">
              <template slot-scope="scope">
                <span style="color: #67C23A; font-weight: bold;">{{ scope.row.succAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="succCnt" :label="$t('home.succCnt')" align="center">
              <template slot-scope="scope">
                <span style="color: #67C23A; font-weight: bold;">{{ scope.row.succCnt }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="failAmount" :label="$t('home.failAmount')" align="center">
              <template slot-scope="scope">
                <span style="color: #F56C6C; font-weight: bold;">{{ scope.row.failAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="failCnt" :label="$t('home.failCnt')" align="center">
              <template slot-scope="scope">
                <span style="color: #F56C6C; font-weight: bold;">{{ scope.row.failCnt }}</span>
              </template>
            </el-table-column>
&lt;!&ndash;            <el-table-column prop="growth" label="环比增长" align="center">&ndash;&gt;
&lt;!&ndash;              <template slot-scope="scope">&ndash;&gt;
&lt;!&ndash;                <span :style="{ color: scope.row.growth > 0 ? '#67C23A' : '#F56C6C' }">&ndash;&gt;
&lt;!&ndash;                  <i :class="scope.row.growth > 0 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>&ndash;&gt;
&lt;!&ndash;                  {{ Math.abs(scope.row.growth) }}%&ndash;&gt;
&lt;!&ndash;                </span>&ndash;&gt;
&lt;!&ndash;              </template>&ndash;&gt;
&lt;!&ndash;            </el-table-column>&ndash;&gt;
          </el-table>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card shadow="hover" class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-bar-chart"></i> {{ $t('home.proportion') }}</span>
          </div>
          <div ref="rateChart" style="width: 100%; height: 300px;"></div>
        </el-card>
      </el-col>

    </el-row>-->
    <el-row :gutter="20" class="chart-section">

      <el-col :span="24">

        <el-card shadow="hover" class="box-card">


          <div slot="header" class="clearfix">

        <span>
          <i class="fa fa-line-chart"></i>
          {{ $t('home.WeeklyData') }}
        </span>

          </div>

          <el-table
              :data="weeklyData"
              stripe
              border
              :max-height="360"
              style="width:100%">


            <!-- 日期 -->
            <el-table-column
                prop="trDate"
                :label="$t('home.Date')"
                align="center"
                width="120">
            </el-table-column>


            <!-- 币种 -->
            <el-table-column
                prop="currency"
                :label="$t('home.currency')"
                align="center"
                width="100">

              <template slot-scope="scope">

                <el-tag type="primary">
                  {{scope.row.currency}}
                </el-tag>

              </template>

            </el-table-column>




            <!-- 网关号 -->
            <el-table-column
                prop="gwNo"
                :label="$t('home.gwNo')"
                align="center"
                width="150">
            </el-table-column>


            <!-- 总金额 -->
            <el-table-column
                prop="amount"
                :label="$t('home.amountCnt')"
                align="center">

              <template slot-scope="scope">

            <span class="amount-text">
              {{scope.row.amount}}
            </span>

              </template>


            </el-table-column>



            <!-- 总笔数 -->
            <el-table-column
                prop="cnt"
                :label="$t('home.cnt')"
                align="center">
            </el-table-column>


            <!-- 成功金额 -->
            <el-table-column
                prop="succAmount"
                :label="$t('home.succAmount')"
                align="center">

              <template slot-scope="scope">

            <span class="success-text">
              {{scope.row.succAmount}}
            </span>


              </template>


            </el-table-column>



            <!-- 成功笔数 -->
            <el-table-column
                prop="succCnt"
                :label="$t('home.succCnt')"
                align="center">


              <template slot-scope="scope">

            <span class="success-text">
              {{scope.row.succCnt}}
            </span>

              </template>

            </el-table-column>

            <!-- 成功率 -->
            <el-table-column
                prop="succRate"
                :label="$t('home.succRate')"
                align="center">

              <template slot-scope="scope">
                <el-progress
                    :percentage="formatRate(scope.row.succRate)"
                    :stroke-width="12">
                </el-progress>
              </template>


            </el-table-column>




          </el-table>


        </el-card>


      </el-col>


    </el-row>


    <el-row :gutter="20" style="margin-top:20px">

      <el-col :span="24">

        <el-card shadow="hover" class="box-card">


          <div slot="header">
        <span>
          <i class="fa fa-line-chart"></i>
<!--          成功金额趋势-->
          {{$t('home.successAmountTrend')}}
        </span>
          </div>


          <div
              ref="amountTrendChart"
              style="width:100%;height:350px;">
          </div>


        </el-card>

      </el-col>


    </el-row>

  </div>
</template>

<script>

import * as echarts from 'echarts'
export default {
  data() {
    return {
      stats: {
        successAmount: 0,
        allCnt: 0,
        allSuccCnt: 0,
        allFailCnt: 0,
        allSuccRate: 0
      },
      weeklyData: [], // 用于保存一周的表格数据
      // 成功金额趋势图
      amountChartInstance:null
    }
  },
  created() {
    // 加载数据
    this.loadDashboard()
  },

  mounted() {
    window.addEventListener(
        'resize',
        this.resizeChart
    )


  },

  beforeDestroy() {

    if(this.amountChartInstance){

      this.amountChartInstance.dispose();

    }


    window.removeEventListener(
        'resize',
        this.resizeChart
    )
  },

  watch: {
    '$i18n.locale'() {
     // this.updateChart();
      this.initAmountTrendChart();
    }
  },

  methods: {
    // 数据处理
    formatRate(rate) {

      if (!rate) {
        return 0;
      }

      return Number(
          String(rate).replace('%','')
      );

    },
    async loadDashboard() {
      try {
        const res = await this.$axios.get("/api/home/getTradeTot")
        if (res.data && res.data.data) {
          this.stats = res.data.data
        }
      } catch (error) {
        console.error("加载统计数据失败", error)

      }

      try {
        const weekRes = await this.$axios.get("/api/home/getTradeDetails")
        this.weeklyData = weekRes.data.data || []

        // 按日期聚合成功金额（解决同一天多条记录的问题）
        const dateMap = {}
        this.weeklyData.forEach(item => {
          const date = item.trDate
          if (!dateMap[date]) dateMap[date] = 0
          dateMap[date] += Number(item.succAmount || 0)
        })
        // 排序后生成图表专用数据
        this.chartDates = Object.keys(dateMap).sort()
        this.chartAmounts = this.chartDates.map(d => dateMap[d])

        this.$nextTick(() => {
          this.initAmountTrendChart()
        })
      } catch (error) {
        console.error("加载一周数据失败", error)
      }

    },



    resizeChart(){
      if(this.chartInstance){
        this.chartInstance.resize();
      }

      if(this.amountChartInstance){

        this.amountChartInstance.resize();

      }
    },
    // 趋势图
    initAmountTrendChart(){

      if (!this.chartDates || this.chartDates.length === 0) return
      if (!this.$refs.amountTrendChart) return



      if (this.amountChartInstance) {
        this.amountChartInstance.dispose()
      }
      this.amountChartInstance =
          echarts.init(
              this.$refs.amountTrendChart
          );

 /*     let dates = this.weeklyData.map(item=>item.trDate);

      let amounts = this.weeklyData.map(item=>{return Number(item.succAmount || 0);});*/
      let dates = this.chartDates;
      let amounts = this.chartAmounts;
      let option={

        tooltip:{
          trigger:'axis',

          formatter:function(params){

            let data=params[0];

          /*  return `
                日期：${data.axisValue}
                <br/>
                成功金额：
        ${Number(data.value)
                .toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits:2,
                      maximumFractionDigits:2
                    }
                )
            }

        `;*/
            return `
              ${this.$t('home.Date')}：${data.axisValue}
              <br/>
              ${this.$t('home.succAmount')}：
              ${Number(data.value)
                .toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits:2,
                      maximumFractionDigits:2
                    }
                )
            }
  `;

          }

        },


        grid:{

          left:'5%',
          right:'5%',
          bottom:'8%',
          containLabel:true

        },

        xAxis:{

          type:'category',
          data:dates,

          boundaryGap:false,

          axisLabel:{

            rotate:30

          }

        },

        yAxis:{
          type:'value',

          //name:'金额',
          name:this.$t('home.amount'),

          axisLabel:{

            formatter:function(value){

              if(value>=10000){

                return (value/10000)+this.$t('home.tenThousand');

              }
              return value;
            }
          }

        },

        series:[{

          //name:'成功金额',
          name:this.$t('home.succAmount'),
          type:'line',

          smooth:true,

          data:amounts,

          symbol:'circle',
          symbolSize:8,

          lineStyle:{
            width:3
          },

          areaStyle:{

            opacity:0.2

          },


          label:{

            show:true,

            formatter:function(params){

              return params.value;

            },

            position:'top'

          }

        }]

      };

      this.amountChartInstance.setOption(option);

    }
  }
}
</script>

<!--<style scoped>
.dashboard {
  padding: 20px;
  background-color: #f5f7fa; /* 增加一点底色让卡片阴影更明显 */
  min-height: 100vh;
}

.card-title {
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.card-value {
  margin-top: 15px;
  font-size: 32px;
  font-weight: bold;
  color: #303133;
}

.card-desc {
  margin-top: 10px;
  color: #909399;
  font-size: 13px;
}

.chart-section {
  margin-top: 20px;
}

.box-card {
  height: 400px; /* 固定高度保持左右对齐 */
}



#&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;


</style>-->
<style scoped>
/* 保持您最初的样式不变，确保完全兼容外层系统的面包屑与导航布局 */
.dashboard {
  padding: 20px;
}

.card-title {
  color: #666;
  font-size: 14px;
}

.card-value {
  margin-top: 15px;
  font-size: 32px;
  font-weight: bold;
  color: #303133;
}

.card-desc {
  margin-top: 10px;
  color: #909399;
}

/* 仅为下方新加的表格和图表组件提供排版间距，不影响顶部结构 */
.chart-section {
  margin-top: 20px;
}

.box-card {
  min-height: 400px;
  border-radius: 12px;
}

.stat-card {
  height: 150px;
  border-radius: 12px;
  transition: all .3s;
}


.stat-card:hover {
  transform: translateY(-5px);
}



.card-title {
  font-size:14px;
  color:#606266;
  display:flex;
  align-items:center;
}


.card-title i {
  font-size:22px;
  margin-right:8px;
}



.card-value {
  margin-top:20px;
  font-size:30px;
  font-weight:bold;
  color:#303133;
}



.card-desc {
  margin-top:10px;
  color:#909399;
  font-size:13px;
}



/* 不同类型 */

.amount-card .card-title i{
  color:#409EFF;
}


.blue-card .card-title i{
  color:#409EFF;
}


.green-card .card-title i{
  color:#67C23A;
}


.orange-card .card-title i{
  color:#E6A23C;
}


.purple-card .card-title i{
  color:#909399;
}


/*数据表格样式*/
.chart-section{
  margin-top:20px;
}


.box-card{
  border-radius:12px;
}



.clearfix{
  font-size:16px;
  font-weight:bold;
}



.clearfix i{
  margin-right:8px;
  color:#409EFF;
}



.amount-text{
  font-weight:bold;
  color:#409EFF;
}



.success-text{
  font-weight:bold;
  color:#67C23A;
}



</style>



// WEBPACK FOOTER //
// src/view/dashboard/Index.vue